// @/plugins/markdownit.ts
import md from 'markdown-it';

export default defineNuxtPlugin(() => {
  const renderer = md({
    html: true, // Enable HTML tags in source
    linkify: true, // Autoconvert URL-like text to links
    typographer: true, // Enable some language-neutral replacement + quotes beautification
    breaks: true // Convert '\n' in paragraphs into <br>
  });

  return {
    provide: {
      mdRenderer: renderer
    }
  };
});
